import { defaultPageSize, defaultPageSizes } from '../constants'

export interface PaginationModel {
    pageSizes: number[]
    selectedPageSize: number
    pageSizeChanged: Function
    pageNumbers: number[]
    currentPageNumber: number
    gotoPage: Function
}

export interface TableList<T> {
    items: T[]
    currentSortOrder: string
    pagination: PaginationModel
}

export const DefaultPagination = {
    pageSizes: defaultPageSizes,
    selectedPageSize: defaultPageSize,
    pageSizeChanged: () => null,
    pageNumbers: [],
    currentPageNumber: 1,
    gotoPage: () => null,
}

export const DefaultList = {
    items: [],
    currentSortOrder: '',
    pagination: DefaultPagination,
}
